// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-691cc655] .el-dialog__body {\n  padding: 10px;\n  min-height: 250px;\n  overflow: auto;\n}\n.el-form-item--mini.el-form-item[data-v-691cc655] {\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
